(function(window, $, undefined){
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Controls = window.JVZoo.Controls || {};

    var attributeName = 'data-jvz-sortable';
    var tagType = 'jvz-drag-btn';

    var updateOrderFields = function($target) {
        $target.find('[data-jvz-element-order]').each(function(index, element){
            var $element = window.JVZoo.Common.AsjQueryObject(element);
            $element.val(index);
        });
    };

    var sortableConfiguration = {
        stop: function (event, ui) { updateOrderFields($(event.target));},
        containment: "parent"
    };

    var refreshSortable = function($element) {
        var $nearestSortable = $element.closest('[data-checkout-content-features]');
        if ($nearestSortable.length === 1) {
            $nearestSortable.first().sortable('refresh');
        }
    };

    function DragButton(element) {
        var _this = this;
        //if we weren't passed a jQuery object, convert it to one now
        _this.$sourceElement = window.JVZoo.Common.AsjQueryObject(element);

        _this.$renderedElement = $('<div class="jvz-drag-btn" data-jvz-drag-btn>')
            .append($('<i class="fa fa-bars icon">'));
    }

    DragButton.prototype.render = function() {
        var _this = this;
        _this.$sourceElement.replaceWith(
            _this.$renderedElement
        );

        window.JVZoo.Controls.SetFullyQualifiedFieldNames(_this.$renderedElement);
    };

    window.JVZoo.Controls.DragButton = DragButton;

    var applyBindings = function($root) {

        $root.find(tagType).each(function (index, value) {
                var dragButtonControl = new window.JVZoo.Controls.DragButton(value);
                dragButtonControl.render();
            }
        );

        //find the next highest container, or look for all contained sortable lists
        var $containers = $root.closest('['+attributeName+']');
        if (!$containers || $containers.length < 1) {
            $containers = $root.find('['+attributeName+']');
        }

        $containers.each(function(index, value){
            var $sortableList = $(value);
            console.log("Enabling sort for: ", $sortableList);
            //if it is already a sortable, then refresh, otherwise add it
            if ($sortableList.sortable('instance')) {
                $sortableList.sortable('refresh')
            } else {
                $sortableList.sortable(sortableConfiguration);
            }

            //ensure all direct decedents are tracking their order
            console.log("Applying sort order to container: ", $sortableList);
            $sortableList.find('[data-jvz-drag-btn]').each(function(index, value) {
                var $jvzDragBtn = $(value);
                var $existingSortOrderInput = $jvzDragBtn.find('[data-jvz-element-order]');
                if ($existingSortOrderInput && $existingSortOrderInput.length > 0) {
                    //a sort order hidden field has already been included, so update it's value to match it's index
                    $existingSortOrderInput.val(index);
                } else {
                    //a new sort order hidden field needs to be added and its value should also match its index
                    $jvzDragBtn
                        .append(
                            $('<input data-jvz-element-order type="hidden" name="order">').val(index)
                        );
                    //ensure the correct field name is assigned
                    window.JVZoo.Controls.SetFullyQualifiedFieldNames($jvzDragBtn);
                }
            });
        });

    };

    $(document).ready(function() {
        applyBindings($(document));
        window.JVZoo.Controls.NewControlEvent.subscribe(
            this,
            function(args){ applyBindings($(document)); },
            {}
        )
    });
})(window, jQuery);